// Storefront Ad Components
export { default as AdPlacement, useStorefrontAds } from './AdPlacement';
export { default as TextAd } from './TextAd';
export { default as BannerAd } from './BannerAd';

// Ad placement types
export const AD_PLACEMENTS = {
  HOMEPAGE_HERO: 'HOMEPAGE_HERO',
  HOMEPAGE_BANNER: 'HOMEPAGE_BANNER',
  SHOP_INLINE: 'SHOP_INLINE',
  SHOP_SIDEBAR: 'SHOP_SIDEBAR',
  CATEGORY_INLINE: 'CATEGORY_INLINE',
  ABOUT_BANNER: 'ABOUT_BANNER'
};
